import { useRef, useCallback, useMemo } from "react";
import {
  startActivitySession,
  appendActivity,
} from "../lib/api_service/userActivity/user_activity";

export const useActivityTracking = (module, accountId) => {
  const activitySessionIdRef = useRef(null);

  const trackAction = useCallback(
    async (action, status = "SUCCESS", error = null, formValues = {}) => {
      try {
        if (activitySessionIdRef.current) {
          await appendActivity({
            sessionId: activitySessionIdRef.current,
            action,
            module,
            formValues,
            status: status === "FAILED" ? "FAILED" : null,
            error,
          });
        } else {
          const sessionId = await startActivitySession({
            action,
            module,
            accountId,
            formValues,
            status,
            error,
          });
          activitySessionIdRef.current = sessionId;
        }
      } catch (err) {
        console.error("useActivityTracking failed to track action:", err);
      }
    },
    [accountId, module],
  );

  const resetSession = useCallback(() => {
    activitySessionIdRef.current = null;
  }, []);

  // Preserve the current session id so rerun history failures can be appended to the original activity session.
  const snapshotSession = useCallback(() => activitySessionIdRef.current, []);
  const restoreSession = useCallback((id) => {
    activitySessionIdRef.current = id;
  }, []);

  return useMemo(
    () => ({
      trackAction,
      resetSession,
      snapshotSession,
      restoreSession,
    }),
    [trackAction, resetSession, snapshotSession, restoreSession],
  );
};
